<template>
  <v-row
    class="ml-6 permission-row"
  >
    <v-col
      cols="12"
      class="pa-0"
    >
      <v-row>
        <sn-switch
          :value="permission.value"
          :label="permission.display_name"
          :disabled="viewOnly || permission.view_only"
          :data-cy="dataCy"
          @change="handleChange(permission)"
        />
      </v-row>
    </v-col>
    <template v-if="permission.value && permission.children.length > 0">
      <v-col
        v-for="(child, index) in permission.children"
        :key="index"
        class="ml-12 pa-0"
        cols="12"
      >
        <v-row>
          <sn-checkbox
            :input-value="child.value"
            :label="child.display_name"
            :disabled="viewOnly"
            class="my-3"
            simple
            @change="handleChange(child)"
          />
        </v-row>
      </v-col>
    </template>
  </v-row>
</template>

<script>

export default {
  name: 'SrPermissionRow',
  props: {
    permission: {
      type: Object,
      required: true
    },
    viewOnly: {
      type: Boolean,
      required: false,
      default: false
    },
    dataCy: {
      type: String,
      required: false,
      default: ''
    }
  },
  created () {
  },
  methods: {
    handleChange (permission) {
      const changedPermissions = []
      permission.value = !permission.value
      changedPermissions.push(permission.key)
      if (permission.children.length > 0) {
        permission.children.forEach(child => {
          if (child.value !== permission.value) {
            child.value = permission.value
            changedPermissions.push(child.key)
          }
        })
      }
      this.$emit('permissionChange', changedPermissions)
    }
  }
}
</script>

<style lang="scss" scoped>

@import '~/assets/css/snui';

.permission-row {
  margin: 0;
}

::v-deep .v-expansion-panel-header {
  min-height: 32px !important;
}

::v-deep label {
  font-weight: 700 !important;
  font-size: 17px;
}

::v-deep {
  &.v-input--selection-controls {
    padding-top: 0;
    margin-top: 12px;
    margin-bottom: 12px;
    height: 24px;
  }
}

.tooltip {
  margin: 0;
  padding-top: 8px;
  vertical-align: center;
}

</style>
